var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCoffeStation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 118,
    viewBox: "0 0 102 118",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M67.1616 83.1838L33.4826 83.2777L8.79242 100.878L89.3975 96.358L67.1616 83.1838Z",
    fill: "#FFB52E",
    stroke: "#0B0A0B",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 89.571H58.5L63 76.5578L44 73.7289V89.571Z",
    fill: "#FFB52E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M55 47.9015L44 46.571V59.0184L67.5 61.2816L71 49.3999L58.5 48.2682L55 47.9015Z",
    fill: "#FFB52E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M56 34.6055L55 47.9015L58.5 48.2682L59 37.4344H66V34.6055H56Z",
    fill: "#FFB52E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 61.2816L44 59.0184V73.7289L63 76.5578L67.5 61.2816Z",
    fill: "#FFB52E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55 47.9015L44 46.571V59.0184M55 47.9015L56 34.6055H66V37.4344H59L58.5 48.2682M55 47.9015L58.5 48.2682M58.5 48.2682L71 49.3999L67.5 61.2816M44 59.0184L67.5 61.2816M44 59.0184V73.7289M67.5 61.2816L63 76.5578M63 76.5578L58.5 89.571H44V73.7289M63 76.5578L44 73.7289",
    stroke: "#0B0A0B",
    strokeWidth: 2,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5 61.2816L44 59.0184V73.7289L63 76.5578L67.5 61.2816Z",
    fill: "#F33A3E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55 47.9015L44 46.571V59.0184M55 47.9015L56 34.6055H66V37.4344H59L58.5 48.2682M55 47.9015L58.5 48.2682M58.5 48.2682L71 49.3999L67.5 61.2816M44 59.0184L67.5 61.2816M44 59.0184V73.7289M67.5 61.2816L63 76.5578M63 76.5578L58.5 89.571H44V73.7289M63 76.5578L44 73.7289",
    stroke: "#0B0A0B",
    strokeWidth: 2,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCoffeStation);
export default __webpack_public_path__ + "static/media/coffe-station.f600fa724a3a22ceb31f3b64c273b11c.svg";
export { ForwardRef as ReactComponent };